<template>
  <div class="row justify-content-left no-gutters">
    <div v-if="displayDriverLabelOne" class="driver-header-1">
      {{ driverLabelOne }}
    </div>
    <div v-if="displayDriverLabelTwo" class="driver-header-2">
      {{ driverLabelTwo }}
    </div>
    <div v-if="displayDriverLabelThree" class="driver-header-3">
      {{ driverLabelThree }}
    </div>
    <div v-if="displayDriverLabelFour" class="driver-header-4">
      {{ driverLabelFour }}
    </div>
    <div v-if="displayDriverLabelFive" class="driver-header-5 col">
      {{ driverLabelFive }}
    </div>
  </div>
</template>

<script>
export default {
  name: "DriverHeader",
  data() {
    return {};
  },
  props: {
    driverLabelOne: {
      type: String,
      default: ""
    },
    driverLabelTwo: {
      type: String,
      default: ""
    },
    driverLabelThree: {
      type: String,
      default: ""
    },
    driverLabelFour: {
      type: String,
      default: ""
    },
    driverLabelFive: {
      type: String,
      default: ""
    }
  },
  computed: {
    displayDriverLabelOne: function(){
      return this.driverLabelOne != "";
    },
    displayDriverLabelTwo: function(){
      return this.driverLabelTwo != "";
    },
    displayDriverLabelThree: function(){
      return this.driverLabelThree != "";
    },
    displayDriverLabelFour: function(){
      return this.driverLabelFour != "";
    },
    displayDriverLabelFive: function(){
      return this.driverLabelFive != "";
    },
  }
};
</script>
